module.exports = __webpack_public_path__ + "static/media/wholesaler-white-icon.eb5be643.svg";